// extracted by mini-css-extract-plugin
module.exports = {"user-page-body":"layout_user-page-body__3zjqL","admin-page-body":"layout_admin-page-body__3w8AB"};